import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import Style from "./ChangeRequest.module.scss";
import InputUnderline from "../../components/controls/input/InputUnderline";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import {
  changeRequestStatus,
  changeRequestTypes,
  changeRequestPriorities,
  riskStatusOptions,
  riskProbability,
  riskImpact,
  calculatePageSize,
  cashflowLineCategoryOptions,
  getLabelByType,
} from "../../helpers/utils";
import Searchable from "../../components/controls/select/CustomSelect";
import CheckboxInput from "../../components/controls/checkbox/Checkbox";
import service from "../../store/services/changeRequests.service";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";
import scopeService from "../../store/services/scope.service";
import { Avatar, Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from "@fluentui/react-components";
import { dateOnlyFormatted, displayDecimalFormatted, getAccountCurrency, utcToLocalDateTimeString } from "../../utils/systemSettings";
import { AddIconSvg, CalendarIcon } from "../../modules/default-svg";
import Button from "../../components/controls/button";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import HoverCard from "../../components/hoverCard/HoverCard";
import Table from "../../components/controls/tables/Table";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import AssociatedRisks from "../risk/AssociatedRisks";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import { Calendar, CircleDollarSign, ListPlus, Plus, X } from "lucide-react";
import Skeleton from "react-loading-skeleton";
import { generalActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import Chevron from "../../assets/svg/Chevron.svg";
import ChevronUp from "../../assets/svg/ChevronUp.svg";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import moment from "moment";
import { debounce } from "lodash";
import { Link2, FilePlus2 } from "lucide-react";

const ChangeRequest = (props) => {
  const {
    projectID,
    programID,
    portfolioID,
    defaultProject,
    defaultProgram,
    defaultPortfolio,
    allRequests,
    getChangeRequests,
    loading,
    pageLoading,
    createChangeRequest,
    updateChangeRequest,
    deleteChangeRequest,
    pagination,
    error,
    overviewType,
    redirectionId,
    onRedirectionComplete,
  } = props;
  const date = new Date();
  const dispatch = useDispatch();
  const settings = JSON.parse(localStorage.getItem("settings"));
  const permissions = localStorage.getItem("permissions");
  const prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [setting] = useState(settings);
  const [data, setData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [perPageItems] = useState(calculatePageSize());
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [Type, setType] = useState("");
  const [Status, setStatus] = useState("");
  const [Priority, setPriority] = useState("");
  const [sponsor, setSponsor] = useState(null);
  const [ETA, setETA] = useState(null);
  const [Requester, setRequester] = useState("");
  const [AffectedWorkstream, setAffectedWorkstream] = useState("");
  const [AdditionalMaterials, setAdditionalMaterials] = useState("");
  const [risks, setRisks] = useState([]);
  const [ClientId, setClientId] = useState("");
  const [PortfolioId, setPortfolioId] = useState("");
  const [ProgramId, setProgramId] = useState("");
  const [ProjectId, setProjectId] = useState(projectID);
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [checkedAddRisk, setCheckedAddRisk] = useState(false);
  const [riskTitle, setRiskTitle] = useState("");
  const [riskType, setRiskType] = useState("");
  const [riskStatus, setRiskStatus] = useState("");
  const [dateIdentified, setDateIdentified] = useState("");
  const [dateImpact, setDateImpact] = useState("");
  const [probability, setProbability] = useState(1);
  const [impact, setImpact] = useState(1);
  const [isCreate, setIsCreate] = useState(false);
  const [parentType, setParentType] = useState(null);
  const [isHeader, setIsHeader] = useState(true);
  const [scopeOptions, setScopeOptions] = useState([]);
  const [assignedScopes, setAssignedScopes] = useState([]);
  const [scopes, setScopes] = useState([]);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [totalBudget, setTotalBudget] = useState(0);
  const [totalETC, setTotalETC] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [inScope, setInScope] = useState('');
  const [outOfScope, setOutOfScope] = useState('');
  const [supplierResponsibility, setSupplierResponsibility] = useState('');
  const [clientResponsibility, setClientResponsibility] = useState('');
  const [serviceLevel, setServiceLevel] = useState('');
  const [dependenciesExternalConstraints, setDependenciesExternalConstraints] = useState('');
  const [assumptions, setAssumptions] = useState('');
  const [proposalCompletionFinalAcceptance, setProposalCompletionFinalAcceptance] = useState('');
  const [charges, setCharges] = useState('');
  const [invoicingPaymentTerms, setInvoicingPaymentTerms] = useState('');
  const [termination, setTermination] = useState('');
  const [termsConditions, setTermsConditions] = useState('');
  const [estimatedDeliverySchedule, setEstimatedDeliverySchedule] = useState('');
  const [dateFullyExecuted, setDateFullyExecuted] = useState(null);
  const [isAlreadyFullyExecuted, setIsAlreadyFullyExecuted] = useState(false);
  const [showAdditonnalInfo, setShowAdditonnalInfo] = useState(false);
  const [budgetItems, setBudgetItems] = useState([]);
  const [isAddBudgetMenuOpen, setIsAddBudgetMenuOpen] = useState(false);
  const [cashflowLineOptionsByRow, setCashflowLineOptionsByRow] = useState({});
  const cashflowLineSearchDebouncedRefs = useRef({});
  const [tableSearch, setTableSearch] = useState(null);

  const [redirectionItem, setRedirectionItem] = useState(null);
  const [hasProcessedRedirection, setHasProcessedRedirection] = useState(false);

  const budgetCategoryOptions = cashflowLineCategoryOptions;
  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType || "Change Request";



    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }

    getChangeRequests(payload);
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClientOptions([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setProgramOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Change Request";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Change Request";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (programID) {
      queryParam = `?programId=${programID}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const handleDelete = (selectedRow) => {
    // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
    const id = selectedRow?.id;
    if (projectID) {
      deleteChangeRequest({ id: id, parentID: projectID, parent: "Project" });
      return;
    }
    if (programID) {
      deleteChangeRequest({ id: id, parentID: programID, parent: "Program" });
      return;
    }
    if (portfolioID) {
      deleteChangeRequest({
        id: id,
        parentID: portfolioID,
        parent: "Portfolio",
      });
      return;
    }
    deleteChangeRequest({ id: id, parent: "Change Request" });
    setDeletedId(id);
    // localStorage.removeItem("selectedRow");
  };

  const setRiskStatusType = (type) => {
    switch (type) {
      case "Identified":
        return 0;
      case "Accessed":
        return 1;
      case "Prioritized":
        return 2;
      case "Mitigated":
        return 3;
      case "Monitored":
        return 4;
      case "Active":
        return 5;
      case "Closed":
        return 6;
      case "Contingent":
        return 7;
      case "Accepted":
        return 8;
      case "Escalated":
        return 9;
      default:
        return 0;
    }
  };

  const setRequestType = (type) => {
    switch (type) {
      case "Scope":
        return 0;
      case "Schedule":
        return 1;
      case "Budget":
        return 2;
      case "Quality":
        return 3;
      case "Resource":
        return 4;
      default:
        return 0;
    }
  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "Pending":
        return 1;
      case "Approved":
        return 2;
      case "Rejected":
        return 3;
      case "Deferred":
        return 4;
      case "Executing":
        return 5;
      case "Implemented":
        return 6;
      case "Withdraw":
        return 7;
      default:
        return 0;
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const getRequestType = (type) => {
    switch (type) {
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return "Scope";
    }
  };

  const getRequestStatus = (type) => {
    switch (type) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Deferred";
      case 5:
        return "Executing";
      case 6:
        return "Implemented";
      case 7:
        return "Withdraw";
      default:
        return "Initiating";
    }
  };

  const getRequestPriority = (type) => {
    switch (type) {
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "Low";
    }
  };

  const handleCreate = () => {
    setIsCreate(true);
  };

  const handleSave = () => {
    const errors = {};
    if (!Name) errors["name"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      ProjectId: projectID ? projectID : ProjectId?.value,
      Name,
      Type: setRequestType(Type),
      Status: setRequestStatus(Status),
      Priority: setRequestPriority(Priority),
      Requester,
      AffectedWorkstream,
      ETA: ETA,
      Description,
      AdditionalMaterials,
      AssignedScopes: scopes,
      inScope,
      outOfScope,
      supplierResponsibility,
      clientResponsibility,
      serviceLevel,
      dependencies_ExternalConstraints: dependenciesExternalConstraints,
      assumptions,
      proposalCompletion_FinalAcceptance: proposalCompletionFinalAcceptance,
      charges,
      invoicing_PaymentTerms: invoicingPaymentTerms,
      termination,
      terms_Conditions: termsConditions,
      estimated_Delivery_Schedule: estimatedDeliverySchedule,
      dateFullyExecuted,
      budgetItems
    };
    if (Object.keys(selectedRow).length > 0) {
      const risk = {
        Name: riskTitle,
        Type: setRequestType(riskType) || 0,
        Status: setRiskStatusType(riskStatus) || 0,
        DateIdentified: dateIdentified || dateOnlyFormatted(setting, date),
        DateTmpact: dateImpact,
        Probability: probability || 0,
        Impact: impact || 0,
        ChangeRequestId: selectedRow.id,
        ProjectId: ProjectId.value,
      };
      if (checkedAddRisk) payload.Risk = risk;
      if (projectID) {
        updateChangeRequest({
          id: selectedRow.id,
          parentID: projectID,
          parent: "Project",
          payload,
        });
        return;
      }
      if (programID) {
        updateChangeRequest({
          id: selectedRow.id,
          parentID: programID,
          parent: "Program",
          payload,
        });
        return;
      }
      if (portfolioID) {
        updateChangeRequest({
          id: selectedRow.id,
          parentID: portfolioID,
          parent: "Portfolio",
          payload,
        });
        return;
      }
      updateChangeRequest({
        id: selectedRow.id,
        parent: "Change Request",
        payload,
      });
    } else {
      if (projectID) {
        createChangeRequest({
          parentID: projectID,
          parent: "Project",
          payload,
        });
        return;
      }
      if (programID) {
        createChangeRequest({
          parentID: programID,
          parent: "Program",
          payload,
        });
        return;
      }
      if (portfolioID) {
        createChangeRequest({
          parentID: portfolioID,
          parent: "Portfolio",
          payload,
        });
        return;
      }
      createChangeRequest({ parent: "Change Request", payload });
    }

    setRiskTitle("");
    setRiskType("");
    setRiskStatus("");
    setDateIdentified("");
    setDateImpact("");
    setProbability("");
    setImpact("");
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    setCheckedAddRisk(false);
    setRiskTitle("");
  };

  const handleInputChange = (value, name) => {
    if (name === "name") setName(value);
  };

  const fetchChangeRequestData = async () => {
    setIsLoading(true);
    service
      .fetchSingleChangeRequest(selectedRow.id)
      .then((requestData) => {
        setName(requestData.name);
        setType(getRequestType(requestData.type));
        setStatus(getRequestStatus(requestData.status));
        setPriority(getRequestPriority(requestData.priority));
        setSponsor(requestData.sponsor);
        setRequester(`${requestData.requester}`);
        setAffectedWorkstream(`${requestData.affectedWorkstream}`);
        setETA(requestData.eta);
        setDescription(requestData.description);
        setAdditionalMaterials(`${requestData.additionalMaterials}`);
        setRisks(requestData.risks);
        if (requestData.scopes?.length) {
          const newArray = requestData?.scopes.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }));
          const resArray = requestData?.scopes.map((obj) => obj.id);
          setScopes(resArray);
          setAssignedScopes(newArray);
        } else {
          setAssignedScopes([]);
        }
        requestData.client
          ? setClientId({
            label: requestData.client.name,
            value: requestData.client.id,
          })
          : setClientId("");
        requestData.portfolio
          ? setPortfolioId({
            label: requestData.portfolio.name,
            value: requestData.portfolio.id,
          })
          : setPortfolioId("");
        requestData.program
          ? setProgramId({
            label: requestData.program.name,
            value: requestData.program.id,
          })
          : setProgramId("");
        requestData.project
          ? setProjectId({
            label: requestData.project.name,
            value: requestData.project.id,
          })
          : setProjectId("");
        setAttachments(requestData.attachments || []);
        setTotalBudget(requestData.totalBudget);
        setTotalETC(requestData.totalETC);
        setInScope(requestData.inScope);
        setOutOfScope(requestData.outOfScope);
        setSupplierResponsibility(requestData.supplierResponsibility);
        setClientResponsibility(requestData.clientResponsibility);
        setServiceLevel(requestData.serviceLevel);
        setDependenciesExternalConstraints(requestData.dependencies_ExternalConstraints);
        setAssumptions(requestData.assumptions);
        setProposalCompletionFinalAcceptance(requestData.proposalCompletion_FinalAcceptance);
        setCharges(requestData.charges);
        setInvoicingPaymentTerms(requestData.invoicing_PaymentTerms);
        setTermination(requestData.termination);
        setTermsConditions(requestData.terms_Conditions);
        setEstimatedDeliverySchedule(requestData.estimated_Delivery_Schedule);
        setDateFullyExecuted(requestData.dateFullyExecuted);
        setIsAlreadyFullyExecuted(!!requestData.dateFullyExecuted);
        setBudgetItems((requestData.budgets || []).map(budget => {
          if (budget.title) {
            if (budget.title.startsWith(requestData.name + " - ")) {
              budget.title = budget.title.replace(requestData.name + " - ", "");
            }
            else if (budget.title.startsWith(requestData.name)) {
              budget.title = budget.title.replace(requestData.name, "");
            }
          }

          // isNewLine is the authoritative flag from the server (set once at creation and
          // never changed) - cashflowLineId is always populated either way, so it can't be used
          // to tell New and Link apart once a row comes back from a save.
          return { ...budget, linkMode: !budget.isNewLine };
        }));
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const budgetSum = budgetItems.reduce((acc, item) => acc + (item.budget || 0), 0);
    const etcSum = budgetItems.reduce((acc, item) => acc + (item.etc || 0), 0);
    const timeSum = budgetItems.reduce((acc, item) => acc + (item.time || 0), 0);

    setTotalBudget(budgetSum);
    setTotalETC(etcSum);
    setTotalTime(timeSum);
  }, [budgetItems]);

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchChangeRequestData();
      setCheckedAddRisk(false);
      setRiskTitle("");
    } else {
      setClientId("");
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      setName("");
      setType(0);
      setStatus(0);
      setPriority(0);
      setSponsor(null);
      setRequester("");
      setAffectedWorkstream("");
      setETA(null);
      setDescription("");
      setAdditionalMaterials("");
      setRisks([]);
      setScopes([]);
      setScopeOptions([]);
      setAssignedScopes([]);
      setAttachments([]);
      setTotalBudget(0);
      setTotalETC(0);
      setInScope('');
      setOutOfScope('');
      setSupplierResponsibility('');
      setClientResponsibility('');
      setServiceLevel('');
      setDependenciesExternalConstraints('');
      setAssumptions('');
      setProposalCompletionFinalAcceptance('');
      setCharges('');
      setInvoicingPaymentTerms('');
      setTermination('');
      setTermsConditions('');
      setEstimatedDeliverySchedule('');
      setDateFullyExecuted(null);
      setIsAlreadyFullyExecuted(false);
      setShowAdditonnalInfo(false);
      setBudgetItems([]);
    }
  }, [selectedRow, isEdit]);

  useEffect(() => {
    if (error !== "") {
      error &&
        Object.keys(error).forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  useEffect(() => {
    if (Name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, Name]);

  const searchScopeHandler = (value) => {
    let payload;
    if (parentType === "Project") {
      payload = {
        projectId: projectID,
        value,
      };
    } else {
      payload = {
        projectId: ProjectId.value,
        value,
      };
    }

    if (payload.projectId) {
      scopeService
        .searchScopeRequest(payload)
        .then((res) => {
          const transformedArray = res.map((obj) => ({
            label: obj.name,
            value: obj.id,
          }));
          setScopeOptions(transformedArray);
        })
        .catch(() => {
          setScopeOptions([]);
        });
    } else {
      setScopeOptions([]);
    }
  };

  const setIsFullyExecuted = () => {
    setDateFullyExecuted(dateFullyExecuted ? null : moment().utc().format())
  }

  const handleAddBudget = (linkMode) => {
    if (budgetCategoryOptions.length === 0) return;

    setBudgetItems(prev => [
      ...prev,
      {
        category: budgetCategoryOptions[0].value,
        budget: 0,
        time: 0,
        etc: 0,
        title: '',
        cashflowLineId: null,
        cashflowLineDescription: null,
        linkMode,
      }
    ]);
    setIsAddBudgetMenuOpen(false);
  };

  const handleRemoveBudget = (index) => {
    setBudgetItems(prev => {
      if (index === -1) return prev;
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
    // Cached search results are keyed by row index, which shifts on removal - clearing them is
    // simpler than re-indexing, and each row already shows its own selected line via defaultVal.
    setCashflowLineOptionsByRow({});
  };

  const searchCashflowLineForRow = (index, searchProjectId, value) => {
    if (!searchProjectId) {
      setCashflowLineOptionsByRow(prev => ({ ...prev, [index]: [] }));
      return;
    }
    // No per-search loading flag on purpose - matches InvoiceRegistry's Payment Code picker
    // (searchCashflowLineHandler there has an empty .finally()). Toggling Searchable's `loading`
    // prop while the field is open swaps its <Select> for a <Skeleton> mid-interaction, which
    // unmounts the open dropdown out from under the user - it must only reflect the CR's own
    // isLoading, never this in-flight search.
    projectService
      .getProjectCashflowLookup(searchProjectId, { description: value || "" })
      .then((data) => {
        setCashflowLineOptionsByRow(prev => ({ ...prev, [index]: data.lines || [] }));
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong while searching cashflow lines. Please try again later.",
            type: "error",
          })
        );
      });
  };

  // The debounce wrapper is created once per row and reused - it must not close over projectID/
  // ProjectId (they'd go stale), so the current project id is passed in as an argument on every
  // call instead of being read from closure.
  const handleCashflowLineSearch = (index, value) => {
    if (!cashflowLineSearchDebouncedRefs.current[index]) {
      cashflowLineSearchDebouncedRefs.current[index] = debounce(
        (idx, searchProjectId, val) => searchCashflowLineForRow(idx, searchProjectId, val),
        400
      );
    }
    cashflowLineSearchDebouncedRefs.current[index](index, projectID || ProjectId?.value, value);
  };

  const handleCashflowLineChange = (index, selected) => {
    const updated = [...budgetItems];
    updated[index] = {
      ...updated[index],
      cashflowLineId: selected ? selected.value : null,
      cashflowLineDescription: selected ? selected.label : null,
    };
    setBudgetItems(updated);
  };

  // A line already picked by another row in this same change request can't be picked again.
  const cashflowLineOptionsForRow = (index) => {
    const options = cashflowLineOptionsByRow[index] || [];
    const takenElsewhere = new Set(
      budgetItems
        .filter((b, i) => i !== index && b.cashflowLineId)
        .map(b => b.cashflowLineId)
    );
    return options
      .filter(option => !takenElsewhere.has(option.id))
      .map(option => ({
        label: `${getLabelByType("cashflowLineCategory", option.category)} - ${option.description}`,
        value: option.id,
      }));
  };
  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Add change request title "
          value={Name}
          error={formErrors.name}
          handleChange={(value) => handleInputChange(value, "name")}
          isRequired
          loading={isLoading}
        />
        <div className="row align-items-center mt-3 mb-3 gx-5">
          <div className="flex">
            {
              isLoading ?
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
                :
                (
                  (isAlreadyFullyExecuted && dateFullyExecuted) ?
                    <p
                      style={{ border: "1px solid #342C82" }}
                      className={`d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]`}
                    >
                      Fully Executed - {utcToLocalDateTimeString(setting, dateFullyExecuted)}
                    </p>
                    :
                    <ModalCheckbox
                      label={dateFullyExecuted ? `Fully Executed - ${utcToLocalDateTimeString(setting, dateFullyExecuted)}` : `Mark as Fully Executed`}
                      checked={dateFullyExecuted ? true : false}
                      setChecked={setIsFullyExecuted}
                    />
                )

            }

          </div>
        </div>
        {isEdit && <AssociatedRisks isLoading={isLoading} risks={risks} />}
        <>
          {Object.keys(selectedRow).length > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <CheckboxInput
                label="Add risk"
                checked={checkedAddRisk}
                setChecked={() => setCheckedAddRisk(!checkedAddRisk)}
              />
            </div>
          )}
          {checkedAddRisk && (
            <div className="bg-white border border-gray-300 rounded-lg p-1 mb-3">
              <div className="row align-items-center p-2 gx-3">
                <div className="col-4">
                  <Input
                    value={`${riskTitle}`}
                    type="text"
                    handleChange={setRiskTitle}
                    label="Title"
                    placeholder="Enter Title"
                    loading={isLoading}
                  />
                </div>
                <div className="col-4">
                  <DropDown
                    label="Type"
                    options={changeRequestTypes}
                    defaultVal={riskType}
                    onChange={setRiskType}
                    loading={isLoading}
                  />
                </div>
                <div className="col-4">
                  <DropDown
                    label="Status"
                    options={riskStatusOptions}
                    defaultVal={riskStatus}
                    onChange={setRiskStatus}
                    loading={isLoading}
                  />
                </div>
              </div>
              <div className="row align-items-center p-2 gx-3">
                <div className="col-3">
                  <Input
                    value={dateIdentified}
                    type="date"
                    handleChange={setDateIdentified}
                    label="Date Identified"
                    placeholder="Enter Date"
                    loading={isLoading}
                  />
                </div>
                <div className="col-3">
                  <Input
                    value={dateImpact}
                    type="date"
                    handleChange={setDateImpact}
                    label="Impact Date"
                    placeholder="Enter Date"
                    loading={isLoading}
                  />
                </div>
                <div className="col-3">
                  <DropDown
                    label="Probability"
                    options={riskProbability}
                    defaultVal={probability}
                    onChange={setProbability}
                    loading={isLoading}
                  />
                </div>
                <div className="col-3">
                  <DropDown
                    label="Impact"
                    options={riskImpact}
                    defaultVal={impact}
                    onChange={setImpact}
                    loading={isLoading}
                  />
                </div>
              </div>
            </div>
          )}
        </>
        <div className="ModalAvatarGroup">
          <div className="d-flex">
            {parentType !== "Client" &&
              overviewType !== "Portfolio" &&
              overviewType !== "Program" &&
              overviewType !== "Project" && (
                <div className="mt-4 w-50">
                  <Searchable
                    label="Client"
                    SelectText="client"
                    selectWd="me-3"
                    searchText={searchClientHandler}
                    options={clientOptions}
                    defaultVal={ClientId}
                    onChange={(e) => {
                      setClientId(e ?? "");
                      setPortfolioId("");
                      setProgramId("");
                      setProjectId("");
                    }}
                    loading={isLoading}
                  />
                </div>
              )}
            {overviewType !== "Portfolio" &&
              overviewType !== "Program" &&
              overviewType !== "Project" && (
                <div className="mt-4 w-50">
                  <Searchable
                    label="Portfolio"
                    SelectText="portfolio"
                    selectWd="me-3"
                    searchText={searchPortfolioHandler}
                    options={portfolioOptions}
                    defaultVal={PortfolioId}
                    onChange={(e) => {
                      setPortfolioId(e ?? "");
                      setProgramId("");
                      setProjectId("");
                    }}
                    loading={isLoading}
                  />
                </div>
              )}
          </div>
          <div className="d-flex">
            {overviewType !== "Program" && overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Program"
                  SelectText="program"
                  selectWd="me-3"
                  searchText={searchProgramHandler}
                  options={programOptions}
                  defaultVal={ProgramId}
                  onChange={(e) => {
                    setProgramId(e ?? "");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
            {overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Project"
                  SelectText="project"
                  selectWd="me-3"
                  searchText={searchProjectHandler}
                  options={projectOptions}
                  defaultVal={ProjectId}
                  onChange={(e) => {
                    setProjectId(e ?? "");
                    setScopeOptions([]);
                    setAssignedScopes([]);
                    setScopes([]);
                  }}
                  errorMessage={formErrors.projectId}
                  isRequired
                  loading={isLoading}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          {isEdit && sponsor && (
            <div className="row align-items-center mb-3 gx-3">
              <div className="col-4">
                <div className={Style.overviewAvatarWrapper}>
                  <label class="Input_label">Sponsor</label>
                  <div className="d-flex align-items-center">
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={
                            sponsor
                              ? sponsor?.name ||
                              sponsor?.email ||
                              sponsor?.phone
                              : "--"
                          }
                          image=""
                          color="colorful"
                        />
                      }
                      AvatarName={sponsor?.name || sponsor?.email || sponsor?.phone}
                      AvatarDesignation="Sponsor"
                      AvatarEmail={sponsor?.email}
                      AvatarPhone={sponsor?.phone}
                      AvatarIsExternal={true}
                      CanSendMessage={false}
                    />

                    <p className="text-md-500 ms-1 BaseMainColor">
                      {sponsor
                        ? sponsor?.name || sponsor?.email || sponsor?.phone
                        : "--"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-4">
              <DropDown
                label="Type"
                options={changeRequestTypes}
                defaultVal={Type}
                onChange={setType}
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <DropDown
                label="Priority"
                options={changeRequestPriorities}
                defaultVal={Priority}
                onChange={setPriority}
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <DropDown
                label="Status"
                options={changeRequestStatus}
                defaultVal={Status}
                onChange={setStatus}
                loading={isLoading}
              />
            </div>
          </div>
          <div className="row align-items-center gx-3 mb-3">
            <div className="col-4">
              <Input
                value={`${Requester}`}
                type="text"
                handleChange={setRequester}
                label="Requester"
                placeholder=""
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <Input
                icon={<CalendarIcon />}
                value={ETA}
                type="date"
                handleChange={setETA}
                label="ETA (Estimated date to complete)"
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <Searchable
                label="Affected Scope items or Milestones"
                SelectText="Scope items or Milestones"
                multiselect={true}
                searchText={searchScopeHandler}
                options={scopeOptions}
                defaultVal={assignedScopes}
                onChange={(value) => setScopes(value)}
                loading={isLoading}
              />
            </div>
          </div>
          <div className={`bg-white border border-gray-300 rounded-lg p-3 mb-4`} style={{ fontFamily: 'Figtree' }}>
            <div className="flex align-items-center justify-between mb-4 pb-3 border-b border-gray-200">
              <div className="flex align-items-center gap-2">
                <CircleDollarSign className="w-4 h-4" style={{ color: '#342c82' }} />
                <span className="text-sm font-semibold text-gray-800">Budgets</span>
                <Menu
                  open={isAddBudgetMenuOpen}
                  onOpenChange={(e, data) => setIsAddBudgetMenuOpen(data.open)}
                  positioning="below-start"
                >
                  <MenuTrigger disableButtonEnhancement>
                    <button
                      className=""
                      title="Add new budget"
                    >
                      <Plus size={20} className="p-[2px] bg-none border-none text-[#342c82] cursor-pointer rounded  duration-100 ease-in-out hover:bg-[#342c82] hover:text-white" />
                    </button>
                  </MenuTrigger>
                  <MenuPopover>
                    <MenuList>
                      <MenuItem icon={<FilePlus2 size={14} />} onClick={() => handleAddBudget(false)}>
                        New Budget
                      </MenuItem>
                      <MenuItem icon={<Link2 size={14} />} onClick={() => handleAddBudget(true)}>
                        Link Existing Line
                      </MenuItem>
                    </MenuList>
                  </MenuPopover>
                </Menu>
              </div>
              <div className="flex align-items-center gap-4">
                <div className="flex align-items-center gap-2">

                  {isLoading ? (
                    <Skeleton
                      height={30}
                      baseColor="#e0e0e0"
                      highlightColor="#ECE7FD"
                    />
                  ) : (
                    <>
                      <span className="text-xs text-gray-600 font-medium">Total Value</span>
                      <p
                        style={{ border: "1px solid #342C82" }}
                        className=" d-flex align-items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-xs font-bold text-center rounded-md h-[25px]"
                      >
                        {getAccountCurrency(setting)}  {displayDecimalFormatted(setting, totalBudget)}
                      </p>
                    </>
                  )}
                </div>

                <div className="flex align-items-center gap-2">
                  {isLoading ? (
                    <Skeleton
                      height={30}
                      baseColor="#e0e0e0"
                      highlightColor="#ECE7FD"
                    />
                  ) : (
                    <>
                      <span className="text-xs text-gray-600 font-medium">Total ETC</span>
                      <p
                        style={{ border: "1px solid #342C82" }}
                        className=" d-flex align-items-center justify-star px-[8px] text-xs font-bold text-[#1F1F1F] bg-[#EDECF8] text-center rounded-md h-[25px]"
                      >
                        {getAccountCurrency(setting)}  {displayDecimalFormatted(setting, totalETC)}
                      </p>
                    </>
                  )}
                </div>

                <div className="flex align-items-center gap-2">
                  {isLoading ? (
                    <Skeleton
                      height={30}
                      baseColor="#e0e0e0"
                      highlightColor="#ECE7FD"
                    />
                  ) : (
                    <>
                      <span className="text-xs text-gray-600 font-medium">Total Time</span>
                      <p
                        style={{ border: "1px solid #342C82" }}
                        className=" d-flex align-items-center justify-star px-[8px] text-xs font-bold text-[#1F1F1F] bg-[#EDECF8] text-center rounded-md h-[25px]"
                      >
                        {displayDecimalFormatted(setting, totalTime)}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>

            {budgetItems && budgetItems.map((budget, index) => {
              const isSaved = !!budget.id;
              return (
              <div key={index} className="flex align-items-center gap-1 mb-2">
                <div className="flex w-[90%] gap-2 align-items-end">
                  <div className="col-3">
                    {isSaved ? (
                      // A saved row's line is fixed either way (new or linked) - show which one,
                      // not a control that implies it could still be changed. The icon next to the
                      // label is the only remaining New/Link indicator now that mode is chosen
                      // up front from the "+" menu rather than toggled inline on the row.
                      <div>
                        <label className="Input_label d-flex align-items-center gap-1">
                          {budget.isNewLine ? <FilePlus2 size={12} /> : <Link2 size={12} />}
                          Line
                        </label>
                        {isLoading ? (
                          <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
                        ) : (
                          <p
                            style={{ border: "1px solid #342C82" }}
                            className="d-flex align-items-center px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-xs font-bold rounded-md h-[40px] text-truncate"
                            title={budget.cashflowLineDescription}
                          >
                            {budget.cashflowLineDescription}
                          </p>
                        )}
                      </div>
                    ) : budget.linkMode ? (
                      <Searchable
                        label="Cashflow Line"
                        SelectText="line"
                        isRequired
                        defaultVal={
                          budget.cashflowLineId
                            ? { value: budget.cashflowLineId, label: budget.cashflowLineDescription }
                            : null
                        }
                        searchText={(value) => handleCashflowLineSearch(index, value)}
                        options={cashflowLineOptionsForRow(index)}
                        onChange={(selected) => handleCashflowLineChange(index, selected)}
                        loading={isLoading}
                        isDisabled={dateFullyExecuted}
                      />
                    ) : (
                      <DropDown
                        label="Category"
                        options={budgetCategoryOptions}
                        defaultVal={getLabelByType("cashflowLineCategory", budget.category)}
                        onChange={(val) => {
                          const updated = [...budgetItems];
                          updated[index].category = val;
                          setBudgetItems(updated);
                        }}
                        loading={isLoading}
                        StyleClass={dateFullyExecuted ? 'cursor-not-allowed' : ''}
                        disabled={dateFullyExecuted ? true : false}
                      />
                    )}
                  </div>
                  <div className="col-3">
                    <Input
                      placeholder={""}
                      value={budget.linkMode ? '' : budget.title}
                      type="text"
                      handleChange={(val) => {
                        const updated = [...budgetItems];
                        updated[index].title = val;
                        setBudgetItems(updated);
                      }}
                      label="Title"
                      loading={isLoading}
                      inputClass={(dateFullyExecuted || budget.linkMode) ? 'cursor-not-allowed' : ''}
                      isDisabled={dateFullyExecuted || budget.linkMode ? true : false}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      placeholder={`${getAccountCurrency(setting)} 0`}
                      value={budget.budget}
                      type="number"
                      handleChange={(val) => {
                        const updated = [...budgetItems];
                        updated[index].budget = parseFloat(val) || 0;
                        setBudgetItems(updated);
                      }}
                      currency={true}
                      label="Budget"
                      loading={isLoading}
                      inputClass={dateFullyExecuted ? 'cursor-not-allowed' : ''}
                      isDisabled={dateFullyExecuted ? true : false}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      placeholder={`0`}
                      value={budget.time}
                      type="number"
                      handleChange={(val) => {
                        const updated = [...budgetItems];
                        updated[index].time = parseFloat(val) || 0;
                        setBudgetItems(updated);
                      }}
                      label="Time"
                      loading={isLoading}
                      inputClass={dateFullyExecuted ? 'cursor-not-allowed' : ''}
                      isDisabled={dateFullyExecuted ? true : false}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      placeholder={`${getAccountCurrency(setting)} 0`}
                      value={budget.etc}
                      type="number"
                      handleChange={(val) => {
                        const updated = [...budgetItems];
                        updated[index].etc = parseFloat(val) || 0;
                        setBudgetItems(updated);
                      }}
                      currency={true}
                      label="ETC"
                      loading={isLoading}
                      inputClass={dateFullyExecuted ? 'cursor-not-allowed' : ''}
                      isDisabled={dateFullyExecuted ? true : false}
                    />
                  </div>
                </div>
                {
                  !dateFullyExecuted && (
                    <div className="flex w-[10%] align-items-center justify-center pt-[30px]">
                      <button
                        onClick={() => handleRemoveBudget(index)}
                        title="Remove budget"
                      >
                        <X
                          size={20}
                          className="text-[#b91c1c] cursor-pointer rounded transition duration-100 ease-in-out hover:bg-[#b91c1c] hover:text-white"
                        />
                      </button>
                    </div>
                  )
                }
              </div>
              );
            })
            }
          </div>
          <div className="mb-3">
            <RichTextEditor
              label="Description"
              content={Description}
              onChange={setDescription}
              loading={isLoading}
            />
          </div>
          <EntityFileUpload
            entityId={selectedRow.id}
            entityType="ChangeRequest"
            attachments={attachments}
            onAttachmentsChange={() => {
              if (selectedRow.id) {
                service
                  .fetchSingleChangeRequest(selectedRow.id)
                  .then((changeRequestData) => {
                    setAttachments(changeRequestData.attachments);
                  })
                  .catch((error) => {
                    console.error("Error fetching change request data:", error);
                  });
              }
            }}
            disabled={isLoading || !selectedRow.id}
          />
          <div className={`bg-white border border-gray-300 rounded-lg p-2 mb-4 mt-3 cursor-pointer`}>
            <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-200" onClick={() => setShowAdditonnalInfo(!showAdditonnalInfo)}>
              <div className="flex items-center gap-2">
                <ListPlus className="w-4 h-4" style={{ color: '#342c82' }} />
                <span className="text-sm font-semibold text-gray-800">Additional Information</span>
              </div>
              <div className="flex items-center gap-4">
                <img
                  className="ml-2"
                  src={showAdditonnalInfo ? ChevronUp : Chevron}
                  alt=""
                />
              </div>
            </div>

            {
              showAdditonnalInfo && (
                <div className="p-1">
                  <div className="mb-3">
                    <RichTextEditor
                      label="Additional Materials"
                      content={AdditionalMaterials}
                      onChange={setAdditionalMaterials}
                      loading={isLoading}
                    />
                  </div>
                  <div className="mb-3">
                    <RichTextEditor
                      label="In Scope"
                      content={inScope}
                      onChange={setInScope}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Out of Scope"
                      content={outOfScope}
                      onChange={setOutOfScope}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Supplier Responsibility"
                      content={supplierResponsibility}
                      onChange={setSupplierResponsibility}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Client Responsibility"
                      content={clientResponsibility}
                      onChange={setClientResponsibility}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Service Level"
                      content={serviceLevel}
                      onChange={setServiceLevel}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Dependencies / External Constraints"
                      content={dependenciesExternalConstraints}
                      onChange={setDependenciesExternalConstraints}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Assumptions"
                      content={assumptions}
                      onChange={setAssumptions}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Proposal Completion / Final Acceptance"
                      content={proposalCompletionFinalAcceptance}
                      onChange={setProposalCompletionFinalAcceptance}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Charges"
                      content={charges}
                      onChange={setCharges}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Invoicing / Payment Terms"
                      content={invoicingPaymentTerms}
                      onChange={setInvoicingPaymentTerms}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Termination"
                      content={termination}
                      onChange={setTermination}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Terms & Conditions"
                      content={termsConditions}
                      onChange={setTermsConditions}
                      loading={isLoading}
                    />
                  </div>

                  <div className="mb-3">
                    <RichTextEditor
                      label="Estimated Delivery Schedule"
                      content={estimatedDeliverySchedule}
                      onChange={setEstimatedDeliverySchedule}
                      loading={isLoading}
                    />
                  </div>

                </div>
              )
            }

          </div>
        </div>
      </>
    );
  };
  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);

    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3);
  }, []);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  // useEffect(() => {
  //   if (allRequests && allRequests.length > 0) {
  //     if (isCreateNewRow) {
  //       setData(
  //         allRequests.sort((a, b) => {
  //           return b.isFlagged - a.isFlagged;
  //         })
  //       );
  //       setIsCreateNewRow(false);
  //     } else {
  //       setData((prevData) => {
  //         const newData = [...prevData, ...allRequests].reduce(
  //           (unique, item) => {
  //             return unique.some(
  //               (allocatedResource) => allocatedResource.id === item.id
  //             )
  //               ? unique
  //               : [...unique, item];
  //           },
  //           []
  //         );
  //         return newData
  //           .filter((item) => item.id !== deleteId)
  //           .sort((a, b) => {
  //             return b.isFlagged - a.isFlagged;
  //           });
  //       });
  //     }
  //   }
  // }, [allRequests]);

  useEffect(() => {
    if (allRequests && allRequests.length > 0) {
      if (isCreateNewRow) {
        setData(
          allRequests.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allRequests
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => {
                return b.isFlagged - a.isFlagged;
              })
          );
        } else {
          setData((prevData) => {
            const newMap = new Map(allRequests.map((item) => [item.id, item]));

            const updatedPrevData = prevData.map((item) =>
              newMap.has(item.id) ? newMap.get(item.id) : item
            );

            const prevDataIds = new Set(prevData.map((item) => item.id));
            const newItems = allRequests.filter(
              (shift) => !prevDataIds.has(shift.id)
            );

            return [...updatedPrevData, ...newItems]
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => b.isFlagged - a.isFlagged);
          });
        }
      }
    } else if (allRequests && allRequests.length === 0 && pageNum === 1) {
      setData([]);
    }
  }, [allRequests, deleteId, pageNum, isCreateNewRow]);

  useEffect(() => {
    if (projectID) {
      setProjectId(projectID);
      setParentType("Project");
      setIsHeader(false);
    } else if (programID) {
      setParentType("Program");
      setIsHeader(false);
    } else if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
  }, [projectID, programID, portfolioID]);

  useEffect(() => {
    if (defaultProject && defaultProject.hasOwnProperty("name")) {
      setProjectId({
        label: defaultProject.name,
        value: defaultProject.id,
      });
    }
  }, [defaultProject]);

  useEffect(() => {
    if (defaultProgram && defaultProgram.hasOwnProperty("name")) {
      setProgramId({
        label: defaultProgram.name,
        value: defaultProgram.id,
      });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (defaultPortfolio && defaultPortfolio.hasOwnProperty("name")) {
      setPortfolioId({
        label: defaultPortfolio.name,
        value: defaultPortfolio.id,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (ProjectId && !manualUpdate.current.program) {
      if (!ClientId && !PortfolioId && !ProgramId && !projectID) {
        projectService
          .getProjectDetailsRequest({ id: ProjectId.value })
          .then((projectData) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.program = true;
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            projectData.client
              ? setClientId({
                label: projectData.client.name,
                value: projectData.client.id,
              })
              : setClientId("");
            projectData.portfolio
              ? setPortfolioId({
                label: projectData.portfolio.name,
                value: projectData.portfolio.id,
              })
              : setPortfolioId("");
            projectData.program
              ? setProgramId({
                label: projectData.program.name,
                value: projectData.program.id,
              })
              : setProgramId("");
          })
          .catch((error) =>
            console.error("Error fetching project data:", error)
          );
      }
    }
  }, [ProjectId]);

  useEffect(() => {
    if (!ProgramId) {
      setProjectId("");
    }
    if (ProgramId && !manualUpdate.current.portfolio) {
      if (!ClientId && !PortfolioId) {
        programService
          .fetchProgramDataRequest({ id: ProgramId.value })
          .then((data) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            data.client
              ? setClientId({ label: data.client.name, value: data.client.id })
              : setClientId("");
            data.portfolio
              ? setPortfolioId({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolioId("");
            setProjectId(""); // Clear ProjectId when ProgramId changes
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      } else {
        if (!isEdit) {
          setProjectId("");
        }
      }
    }
  }, [ProgramId]);

  useEffect(() => {
    if (!PortfolioId) {
      setProgramId("");
      setProjectId("");
    }
    if (PortfolioId && !manualUpdate.current.client) {
      if (!ClientId) {
        portfolioService
          .getPortfolioDetails({ id: PortfolioId.value })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClientId({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClientId("");
            setProgramId("");
            setProjectId("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgramId("");
          setProjectId("");
        }
      }
    }
  }, [PortfolioId]);

  useEffect(() => {
    if (!ClientId) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
    }
    if (ClientId) {
      prevClientId.current = ClientId.value;
    }
    // if (ClientId && prevClientId.current === null) {
    //   prevClientId.current = ClientId.value;
    // }
    if (ClientId && prevClientId.current !== ClientId.value) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      prevClientId.current = ClientId.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [ClientId]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  // Reset redirection flag when redirectionId changes or is cleared
  useEffect(() => {
    if (!hasProcessedRedirection && redirectionId) {
      setHasProcessedRedirection(true);
      setRedirectionItem({ id: redirectionId });

      if (onRedirectionComplete) {
        onRedirectionComplete();
      }
    }
  }, [redirectionId]);

  return (
    <ColumnConfigProvider
      tableName={parentType ? `${parentType}-Change Request` : "Change Request"}
    >
      <div className="listingScreen position-relative">
        {isHeader && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Change Requests</h4>
            {permissions?.includes("ChangeRequest.Create") && (
              <Button
                btnClass="d_btn d_btn_primary"
                icon={<AddIconSvg />}
                label="Add Change Request"
                clickHandler={handleCreate}
              />
            )}
          </div>
        )}

        <Table
          parentType={parentType}
          isHeader={isHeader}
          type="Change Request"
          rows={data || []}
          body={formBody()}
          searchHandler={handleSearch}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          setSelectedRow={setSelectedRow}
          portfolioId={portfolioID}
          programId={programID}
          projectId={projectID}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          setData={setData}
          triggerSearch={handleSearchTrigger}
          forceShowEditModal={redirectionItem}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default ChangeRequest;
